import React, { useState } from "react";
import { Edit, FormTab, TabbedForm } from "react-admin";
import {
  PublishEditAside,
  PublishEditToolbar,
} from "lib/components/PublishEdit";
import { DetailsTab } from "./components/DetailsTab";
import { ContentTab } from "./components/ContentTab";
import { StructureTab } from "./components/StructureTab";
import { AssetPathsTab } from "./components/AssetPathsTab";

export const ProgramEdit = (props) => {
  const [isFormDirty, setIsFormDirty] = useState(false);

  return (
    <Edit
      {...props}
      mutationMode="pessimistic"
      aside={
        <PublishEditAside
          config={{
            resource: "programs",
            resourceLabel: "Program",
          }}
          isFormDirty={isFormDirty}
        />
      }
    >
      <TabbedForm
        toolbar={<PublishEditToolbar setIsFormDirty={setIsFormDirty} />}
        warnWhenUnsavedChanges
      >
        <FormTab label="details">
          <DetailsTab />
        </FormTab>
        <FormTab label="content">
          <ContentTab source="content" />
        </FormTab>
        <FormTab label="structure">
          <StructureTab source="blocks" />
        </FormTab>
        <FormTab label="asset paths">
          <AssetPathsTab />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
